import {MonthlyOfficeVisitReport} from "../../api/VisitWithStatStore";
import {CsvModel} from "../../util/CSVWriteUtil";

export function downloadGhostUsagesCsv(report: MonthlyOfficeVisitReport) {
    type Row = {
        keyNumber: string,
        usageByDate: Map<string, string>,
    };

    const rows: Row[] = report.validation.ghostUsages.map(ghostUsage => {
        return {
            keyNumber: ghostUsage.keyNumber,
            usageByDate: new Map(
                ghostUsage.usages.map(u => [
                    u.date,
                    u.type === 'ghost' ? u.locationTypes.join(", ") : u.type,
                ]),
            )
        };
    });

    const model = new CsvModel<Row>([
        {
            header: 'Key number',
            value: row => String(row.keyNumber)
        },
        ...report.sheet.dates.map(date => ({
            header: date,
            value: (row: Row) => row.usageByDate.get(date) || ''
        })),
    ]);

    const now = new Date();
    const safeMonth = report.month.replaceAll(/[^a-zA-Z0-9_,-]/g, '_');
    model.downloadCsv(
        `ghost_usages_${safeMonth}_${now.toISOString()}.csv`,
        rows
    );
}
